import React, { useEffect, useState } from "react";
import { LogOut, Menu, UserRound } from "lucide-react";
import { useAppAuth } from "@/auth/AppAuthProvider";

export default function Topbar({ onOpenNavigation }) {
  const { principal, logout } = useAppAuth();
  const [updatedAt, setUpdatedAt] = useState(new Date());

  useEffect(() => {
    const timer = window.setInterval(() => setUpdatedAt(new Date()), 60_000);
    return () => window.clearInterval(timer);
  }, []);

  return <header className="app-topbar">
    <button type="button" className="app-mobile-menu" onClick={onOpenNavigation} aria-label="Open navigation" data-testid="mobile-nav-open"><Menu size={20} /></button>
    <div className="system-status"><i aria-hidden="true" /><strong>Application connected</strong><span>Updated {updatedAt.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}</span></div>
    <div className="app-topbar-actions">
      <div className="app-user-chip"><UserRound size={15} /><span>{principal?.name || principal?.email || "Signed in"}</span><small>{principal?.roles?.[0] || "user"}</small></div>
      {principal?.issuer !== "local-development" && <button type="button" onClick={logout} className="app-icon-button" aria-label="Sign out" title="Sign out"><LogOut size={16} /></button>}
    </div>
  </header>;
}
